import { render, staticRenderFns } from "./formUserAgreementInput.vue?vue&type=template&id=a01c6476"
import script from "./formUserAgreementInput.vue?vue&type=script&lang=js"
export * from "./formUserAgreementInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports